module.exports = __webpack_public_path__ + "img/eeg-man.8a318cff.png";